import { CruiseDetailsContainerProps } from '@msc-b2c/interfaces/types';
import styles from './cruisedetailscontainer.module.scss';

export function CruiseDetailsContainer({ children }: Readonly<CruiseDetailsContainerProps>) {
  return <div className={styles.CruiseDetailsContainer}> {children} </div>;
}

export default CruiseDetailsContainer;
